import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// The translations
const translations = {
  en: {
    translation: {
      "dashboard.devices": "Devices",
      "dashboard.device": "Device",
      "dashboard.deviceType": "Device type",
      "dashboard.notifications": "Notifications",
      "chart.deviceId": "Device ID",
      "chart.deviceIds": "Devices IDs",
      "chart.measurements": "Measurements",
      dashboard: "Dashboard",
      users: "Users",
      roles: "Roles",
      organizations: "Organizations",
      devices: "Devices",
      map: "Map",
      elevation: "Elevation",
      language: "Language",
      account: "Account",
      login: "Login",
      logout: "Logout",
      latestDay: "Day",
      latestWeek: "Week",
      latestMonth: "Month",
      latestThreeMonths: "3 months",
      customDateSelector: "Custom dates",
      OpenInGoogleMaps: "Open In Google Maps",
      doubleClickToOpenInGoogleMaps: "Dobbelclick to open in Google Maps",
      noBatteryData: "No battery data provided!",
      startDate: "Start Date",
      endDate: "End Date",
      viewFullscreen: "View in full screen",
      exitFullscreen: "Exit full screen",
      hideAdvancedFiltering: "Hide device filtering",
      showAdvancedFiltering: "Show device filtering",
      applyFilter: "Apply filters",
      clearFilter: "Clear filters",
      ownersLabel: "Organizations",
      deviceTypesLabel: "Device types",
      devicesModelsLabel: "Device Models",
      devicesListLabel: "Devices List",
      timePeriodsLabel: "Period",
      loading: "Loading...",
      loadingData: "Loading data...",
      printChart: "Print chart",
      downloadPNG: "Download PNG",
      downloadJPEG: "Download JPEG",
      downloadPDF: "Download PDF",
      downloadSVG: "Download SVG",
      moreDetails: "More details",
      hideDetails: "Hide details",
      NoMatchingDevicesFound: "No matching devices found",
      NoFiltersSelectedToApply: "No filters selected to apply",
      createNewDevice: "Create new device",
      bulkCreateNewDevices: "Bulk create devices",
      GetCurrentGeolocation: "Get current location",
      geolocationAlertMSG_PERMISSION_DENIED: "You denied the request for Geolocation.",
      geolocationAlertMSG_POSITION_UNAVAILABLE: "Location information is unavailable.",
      geolocationAlertMSG_TIMEOUT: "The request to get user location timed out.",
      geolocationAlertMSG_UNKNOWN_ERROR: "An unknown error occurred.",
      geolocationAlertMSG_HAS_PERMISSION: "Move the Marker on the Map.",
      geolocationAlertMSG_MUST_GIVE_PERMISSION: "You Must give Location Permission to your Browser",
      NoDeviceSelected: "No selected device, please select at least one Device",
      savedGeoLocation: "Saved location",
      geoLocation: "Geolocation(lat,lng)",
      edit: "Edit",
      notifications: "Notifications",
      alert: "Alert",
      alerts: "Alerts",
      alarm: "Alarm",
      alarms: "Alarms",
      value: "Value",
      action: "Action",
      name: "Name",
      cancel: "Cancel",
      confirm: "Confirm",
      add: "Add",
      created: "Created",
      hours_one: "Hour",
      hours_other: "Hours",
      minutes_one: "Minute",
      minutes_other: "Minutes",
      evaluationFrequency: "Evaluation frequency",
      lastRun: "Latest run",
      equal: "Equal to",
      ">=": "Greater than or equal to",
      ">": "Greater than",
      "<=": "Less than or equal to",
      "<": "Less than",
      average: "Avarage",
      minimum: "Minimum",
      maximum: "Maximum",
      total: "Total",
      delete: "Delete",
      confirmAction: "Are you sure you want to perform this action?",
      create: "Create",
      save: "Save",
      counters: "Counters",
      compare: "Compare",
      dataAnalytics: "Data Analytics",
      scheduling: "Scheduling",
      groups: "Groups",
      reference: "Reference",
      period: "Period",
      date: "Date",
      multipleEmails: "Use semicolon to seperate multiple e-mails.",
      organizationHasnoDevices: "This organization has No devices yet",
      obs: "OBS!",
      totalperson: "Total",
      lastReading: "Latest Reading",
      noDataAvailable: "No data available",
      pleaseSelectOrganization: "Please select organization...",
      activities: " Counts",
      activitiesThisPeriod: "For this Period",
      chartRef: "References",
      chartData: "Counts",
      schedulingChartData: "Accumulated counts",
      createNewGroupsFirst: "Please Create new groups first",
      noGroupsFound: "No groups found",
      lastResetAt: "Since reset on ",
      totalCounts: "Total Counts",
      serviceTarget: "Service target",
      setnewThreshold: "Set new service target",
      useSemicolon: "Use semicolon to separate multiple recipients",
      notificationEmails: "Notifications Email(s)",
      serviceThreshold: "Service target",
      apply: "Apply",
      serviceThresholdPlaceholder: "Service Threshold Value (numbers only)",
      chartServiceTargetCount: "Service target",
      resetService: "Reset Service",
      resetServiceHeader: "Service completed!",
      resetServiceMessage: "You have performed service, and want to reset the schedule for ",
      resetSuccessfully: "Service has been reset successfully",
      SetNewThresholdSuccessfully: "New service target has been set",
      day: "Day",
      week: "Week",
      month: "Month",
      noReference: "No reference",
      devicePrevPeriod: "Same device previous period",
      groupAvgSamePeriod: "Same period group avarage",
      resets: "Resets",
      devicesListPlaceholder: "Select one or more devices...",
      interval: "Last received at",
      on: "On",
      counts: "counts",
      at: "at",
      goodRoadTemp: "Road temperature is more than 2°C",
      warningRoadTemp: "Road temperature is between 0°C and 2°C",
      dangerRoadTemp: "Road temperature is less than 0°C",
      inactiveDevice: "inactive",
      activeDevice: "active",
      showMapControls: "Show Map Controls",
      mapThemes: "Map Themes",
      DeviceInfo: "Information",
      DeviceServices: "Services",
      DeviceData: "Data",
      DeviceDownlink: "Downlink",
      DeviceAlarms: "Alarms",
      DeviceContracts: "Contracts",
      DeviceDebugMessages: "Debug",
      debugMessagesLoadError: "Could not load debug messages",
      "debugField.E0": "E0: Modem power-on error",
      "debugField.E1": "E1: Network connect error (120 s)",
      "debugField.E2": "E2: Network connect error (300 s)",
      "debugField.E3": "E3: MQTT config error",
      "debugField.E4": "E4: MQTT connect error",
      "debugField.E5": "E5: MQTT publish error",
      "debugField.S": "S: Send attempts",
      "debugField.A": "A: Avg. send time (s)",
      "debugField.T": "T: Avg. time, all attempts (s)",
      debugMessagesSecondsAxis: "Seconds",
      "form.solution": "Solution",
      "form.serviceCause": "Service Cause",
      "form.device": "Device ID",
      "form.name": "Location name",
      "form.locationId": "Location ID",
      "form.geo.lat": "Latitude",
      "form.geo.lon": "Longitude",
      "form.email": "Email",
      "form.placeName": "Notes",
      "form.serialNumber": "Serial number",
      "form.deleted": "Active",
      "form.state": "State",
      "form.deleted.true": "Yes",
      "form.deleted.false": "No",
      "form.device_model": "Device model",
      "form.device_type": "Device type",
      "form.lastSeenAt": "Last seen",
      "form.created_at": "Created",
      "form.completedAt": "Completed",
      "form.minVWC": "Min VWC",
      "form.maxVWC": "Max VWC",
      "form.elevation": "Elevation(m)",
      "form.boundary_distance": "Boundary Distance(cm)",
      "form.heightOffset": "Height offset(cm)",
      "form.overFlowThreshold": "Overflow threshold(cm)",
      "form.deviceTypes.waterLevel": "Waterlevel devices",
      "form.activeStatus": "Active status",
      "form.owner": "Owner",
      "form.technician": "Technician",
      "form.replacment": "Replacment",
      "replacement.allow": "Allowed",
      "replacement.not_allow": "Not allowed",
      "form.available_solutions": "Available Solutions",
      "form.probeTempOffset": "Temperature offset",
      locationTypeStancode: "Location type",
      requestReplaceDevice: "Request unit replace",
      deactivated: "Deactivated",
      activated: "Activated",
      deleteDevice: "Delete the device permanently",
      takeDownDevice: "Take down the device",
      deleteDeviceMSG: "Are you sure you want to delete this device?",
      takeDownDeviceMSG: "Are you sure you want to take down this device?",
      deleteDeviceWarning: "Be aware that the following data will be deleted:",
      takeDownDeviceWarning: "Be aware that,If you choose, not to preserve the historic data the following data will be deleted:",
      deleteDeviceWarningItem1: "All data will be deleted",
      deleteDeviceWarningItem2: "All integrations will be deleted",
      deleteDeviceWarningItem3: "Relations to other entities(e.g. contracts) will be deleted",
      deviceDeletedSuccess: "Device deleted successfully",
      updateLocation: "Enter geolocation manually",
      update: "Update",
      OldLatValue: "Saved latitude",
      OldLonValue: "Saved longitude",
      filterApplied: "Filter applied",
      countryCode: "Country code",
      mobileNumber: "Phone number",
      dlc_stock: "In Stock",
      dlc_installed: "Installed",
      dlc_taken_down: "Taken down: In stock",
      state: "State",
      from: "From",
      to: "To",
      first: "First",
      last: "Last",
      prev: "Prev",
      next: "Next",
      listOfUsers: "List of users",
      createNewUser: "Create new user",
      search: "Search",
      clear: "Clear",
      listOfDevices: "List of devices",
      deviceType: "Device type",
      deviceModel: "Device model",
      battery: "Battery",
      lastSeenAt: "Last seen",
      globalUserRoles: "Global user roles",
      members: "Members",
      member: "Member",
      contracts: "Contracts",
      contract: "Contract",
      createNewOrg: "Create new Organization",
      listOfOrgs: "List of Organizations",
      activeStatus: "Active status",
      apiKeys: "API Keys",
      apiKey: "API Key",
      optionalContactEmail: "Contact e-mail(optional)",
      addNewMember: "Add new member",
      user: "User",
      remove: "Remove",
      removeMember: "Remove member!",
      sureAboutAction: "Are you sure you want to perform this action?",
      skippedHeartBeat: "Devices that have not sent data in the last 24 hours",
      history: "Logs",
      sent: "Sent",
      channel: "Channel",
      showMembers: "Show members",
      showDevices: "Show devices",
      showList: "show list",
      unknown: "Unknown",
      integration: "Integration",
      externalSystems: "External systems",
      showIntegration: "Show Integrations",
      clientProfileLabel: "Client profile",
      integrationSystemsLabel: "Integration systems",
      integrationSystemsMessage: "Select integration system",
      selectDeviceToIntegrateMessage: "Select devices to integrate",
      clientProfileMessage: "Select Organization profile on external system",
      integrate: "Integrate",
      availableDevices: "Available devices",
      integratedDevices: "Integrated devices",
      noIntegratedDeviceYet: "No Integrated Device Yet",
      bc_home: "Home",
      deleteOrgContact: `Contract "{CNTCT}" will delete from {ORG}.`,
      deleteDeviceIntegration: "This device integration with {SYS} will delete from {ORG}.",
      created_at: "Created at: ",
      lastSyncedAt: "Last Synced at: ",
      tableTolat: "Showing {from} to {to} of {size} {item}",
      compactMode: "Compact mode",
      noDeviceName: "Device name isn't available",
      "table.deviceName": "Device Name",
      "table.deviceId": "Network ID",
      "table.created_at": "Created at",
      "table.completedAt": "Completed at",
      "table.lastSyncedAt": "Last Synced at",
      "table.invoiceFrequencyInMonths": "Billing Frequency",
      "table.package": "Package",
      "table.start_date": "Starting date",
      "table.projectId": "ProjectId (ERP)",
      "table.debitorNumber": "Debitor number(ERP)",
      "table.lastSeenAt": "Last seen at",
      "table.installation_device_note": "Notes",
      actions: "Actions",
      addNewContract: "Add New Contract",
      pck_basic: "Basic",
      pck_premium: "Premium",
      deleteContactDeviceTitle: "Delete a device from contact",
      deleteContactDeviceMSG: "Device '{DEVICE}' will be deleted, Are You sure?",
      contractNoDevices: "This contract does not have any assigned devices yet ",
      installationOrderNoDevices: "This installation order does not have any assigned devices",
      orgNoContracts: "This {item} does not have any assigned contract yet",
      deleteDevicesFirst: "Please remove all Devices assigned to this contract to delete this contract",
      goToContractDetails: "Go to contract details",
      devicePricePerMonth: "Device Price per Month",
      assignDevices: "Assign Devices",
      noAvailableDevices: "No Available Devices",
      select: "Select",
      selectCameraDevice: "Select a camera device...",
      logs: "Logs",
      showContractLogs: "Show Contract Logs",
      hideContractLogs: "Hide Contract Logs",
      contractLogsLabel: "Contract Logs",
      "table.transactions": "Transactions",
      "table.user": "User",
      organization: "Organization",
      deviceNoContract: "No Contracts have this Device",
      "contract.logs.create": "Create",
      "contract.logs.update": "Update",
      "contract.logs.delete": "Delete",
      "contract.logs.add_device_to_contract": "Add device to contract",
      "contract.logs.remove_device_from_contract": "Remove device from contract",
      depitornr: "Debitornr",
      invoiceFrequencyInMonths: "Invoice frequency (month)",
      note: "Note",
      org_name: "Organisation",
      package: "Package",
      projectId: "ProjectId",
      start_date: "Start date",
      user_name: "User",
      services: "Services",
      "tab.installation": "Installation",
      "tab.service-orders": "Services",
      "tab.technicians": "Technicians",
      "tab.service-centers": "Service centres",
      "mode.table": "Table",
      "mode.grid": "Grid",
      "mode.map": "Map",
      "mode.graph": "Graph",
      newOrder: "New Order",
      newTechnician: "Add New Technician",
      addNewUser: "Add new user",
      editUser: "Edit user",
      newServiceCenter: "Add new Service Center",
      "filter.serviceCenter": "Service Center",
      "filter.technician": "Technician",
      "filter.owners": "Owners",
      "filter.userStatus": "User Status",
      "filter.devicesType": "Devices Type",
      "filter.devicesModels": "Devices Models",
      totalDevices: "Total Devices",
      "breadcrumb.home": "Home",
      "breadcrumb.dashboard": "Dashboard",
      "breadcrumb.users": "Users",
      "breadcrumb.user": "User",
      "breadcrumb.roles": "Roles",
      "breadcrumb.role": "Role",
      "breadcrumb.organizations": "Organizations",
      "breadcrumb.organization": "Organization",
      "breadcrumb.devices": "Devices",
      "breadcrumb.device": "Device",
      "breadcrumb.newDevice": "Create device",
      "breadcrumb.map": "Map",
      "breadcrumb.edit": "Edit",
      "breadcrumb.new": "New",
      "breadcrumb.systemIntegrations": "System integrations",
      "breadcrumb.contracts": "Contracts",
      "breadcrumb.contract": "Contract",
      "breadcrumb.apiKeys": "API Keys",
      "breadcrumb.groups": "Groups",
      "breadcrumb.obs": "OBS",
      "breadcrumb.services": "Services",
      "breadcrumb.serviceCenters": "Service centres",
      "breadcrumb.serviceCenterDetails": "Service Center Details",
      "breadcrumb.serviceCenterTechnicians": "Technicians",
      "breadcrumb.newInstallationOrder": "New order",
      "breadcrumb.installations": "Installations",
      "breadcrumb.installationsOrderDetails": "Order Details",
      "breadcrumb.installDevice": "Install Device",
      "breadcrumb.serviceOrders": "Service orders",
      "breadcrumb.serviceWizard": "Perform Service",
      "breadcrumb.serviceDetails": "Service order",
      "breadcrumb.editServiceDetails": "Edit Order",
      "breadcrumb.orders": "Orders",
      addNewServiceCenterTitle: "Add New Service Center",
      editServiceCenterTitle: "Edit Service Center",
      "form.technicians": "Technicians",
      "form.users": "Users",
      "form.usersMSG": "Select users to be added as technicians for this service centre",
      noServiceCenterTechnicians: "No Technicians in this Service Center ",
      "table.status": "Status",
      inactive: "Inactive",
      active: "Active",
      removeTechnicianMgs: "Technician '{name}' will be removed from '{center}', Are You sure?",
      removeTechnicianHeader: "Remove technician form service centre",
      deactivateTTechnicianHeader: "Deactivate technician",
      deactivate: "Deactivate",
      activate: "Activate",
      deactivateTTechnicianMgs: "Technician '{name}' will be deactivated, Are You sure?",
      setAsActive: "Activate this service centre",
      avilableModels: "Available Models",
      avilableModelsMsg: "All Available models in selected Type",
      selectedModels: "Selected Models",
      selectedModelsMsg: "All Models this Technician can do service for",
      selectUserFirst: "Select User First",
      editTecnicianTitle: "Edit technician",
      addSelected: "Add Selected",
      addAll: "Add All",
      removeAllModels: "Remove All",
      filters: "Filters",
      inactiveTechnicianMsg: "This technician is inactive",
      newInstallationOrderTitle: "New Installation Order",
      newServicesOrderTitle: "New Service Order",
      editServicesOrderTitle: "Edit Service Order",
      orderTitle: "Installation order: ",
      "form.orderName": "Name",
      "form.orderOwner": "Owner",
      "form.orderNotes": "Notes",
      "form.orderServiceCenter": "Service Center",
      "form.orderTechnician": "Technician",
      "form.orderDueDate": "Due date",
      "form.types": "Types",
      "form.models": "Models",
      "form.devices": "Devices List",
      "form.deviceNote": "Device Note",
      "form.orderIssue": "Issue",
      "form.startedAt": "Started At",
      noNotes: "No Notes found",
      orderNotes: "Order Notes",
      serviceNotes: "After service notes",
      addToOrder: "Add to order",
      selectPlaceHolder: "Select ...",
      "order.ios_new": "New",
      "order.ios_in_progress": "In-Progress",
      "order.ios_completed": "Done",
      "order.ios_archived": "Archived",
      "order.unknown": "Unknown",
      deleteInstallationOrder: "Installation order '{ORDR}' will be deleted",
      cantDeleteInstallationOrder: "Installation order '{ORDR}' has installed devices, are you sure you need to delete it.",
      deleteInstallationOrderDevice: "Device '{DEVICE}' will be deleted from installation order '{ORDR}'",
      deleteInstallationOrderDeviceAttatchment: "Attachment '{FIL}' will be deleted from service order on device '{DEVICE}'",
      installationOrders: "Installation Order(s)",
      noAttatchments: "No Attachments Found",
      selectFileMsg: "Drag & drop a file here, or click to select a file",
      addNewDevices: "Add devices",
      "installation.installed": "Installed",
      "installation.ready": "Ready for installation",
      viewDetails: "View details",
      installDevice: "Install",
      noOrdersFound: "No Orders Found",
      "step.location": "Unit Location",
      "step.information": "Unit Information",
      "step.beforeService": "Before service images",
      "step.service": "Unit Service",
      "step.replacement": "Unit Replacement",
      "step.causes": "Service Causes",
      "step.afterService": "After Service images",
      "step.data": "Unit Data",
      "step.summary": "Installation Summary",
      "step.finish": "Finish",
      "summary.deviceImages": "Device Images",
      "summary.deviceLocation": "Device Location",
      "summary.deviceData": "Device Data",
      updateLocarion: "Update Location",
      fileTypeError: "This File type isn't supported",
      fileSizeError: "File size is too big, Max file size is 5MB",
      finish: "Finish",
      newFilesLabel: "File/s ready to be uploaded",
      installingDevice: "Submitting device data ...",
      installingDeviceSucceeded: "Device data updated successfully",
      installingDeviceFailed: "Device data update failed",
      uploadingDeviceImagesSucceeded: "Device Images uploaded successfully",
      uploadingDeviceImages: "uploading Device Images ...",
      uploadingDeviceImagesFailed: "uploading Device Images failed",
      showDeviceImages: "Show device images",
      uploadAll: "Upload all",
      notSavedImagesTitle: "Are You Sure",
      notSavedImagesMessage: "Found unuploaded images",
      mustUploadImgMSG: "You must upload at least one image",
      hideInstalled: "Hide Orders with all devices installed",
      AddingNewServiceOrderMsg: "Creating a New Service Order...",
      EditingServiceOrderMsg: "Updating Service Order...",
      AddingServiceOrderAttachmentsMsg: "Uploading Service Order Attachments...",
      noServicesOrdersMsg: "No Services Orders Yet",
      attachments: "Attachments",
      start: "Start",
      restart: "ReStart",
      continue: "Continue",
      archive: "Archive",
      approve: "Approve",
      decline: "Decline",
      reject: "Reject",
      installNewUnit: "Install new unit (Replace)",
      takeUnitDown: "Remove this unit",
      "form.status": "Status",
      "form.issue": "Unit Issue",
      noneAdminPending: "Pending...",
      cannotfindDevice: "Cannot Find Device",
      deviceWorksFine: "Device Works Fine",
      timePeriodsListTitle: "Copy time periods",
      targetDevice: "Select the target device for replacement",
      allData: "All Data",
      today: "Today",
      custom: "Custom",
      deleteServiceOrderMSG: "Are you sure you want to delete Service Order?",
      archiveServiceOrderMSG: "Are you sure you want to archive Service Order?",
      archiveInstallationOrderMSG: "Are you sure you want to archive Installation Order?",
      serviceOrderModalHeader: "Service order quick view card",
      confirmationModalTitle: "Did the installation process go well?",
      confirmationModalMSG: "The device isn't working!",
      addDevice: "Add device",
      selectImage: "Choose image",
      deviceData: "Device data",
      refresh: "Refresh",
      notes: "Notes",
      installationFailed: "The installation failed!",
      owner: "Owner",
      technician: "Technician",
      technicians: "Technicians",
      status: "Status",
      orders: "Orders",
      sos_unknown: "Unknown",
      sos_new: "New",
      sos_in_progress: "In Progress",
      sos_completed: "Completed",
      sos_failed: "Failed",
      sos_archived: "Archived",
      noServiceOrdersMsg: "No Service Orders found",
      ios_new: "New",
      ios_in_progress: "In-Progress",
      ios_completed: "Completed",
      ios_archived: "Archived",
      showObsOnly: "show OBS! List Only",
      duration: "Duration",
      day: "day/s",
      remaining: "remaining",
      showFilters: "Show filters",
      hideFilters: "Hide filters",
      qrcode: "QR-Code",
      deviceQRtitle: "Device QR-Code",
      "downlink.miUnder": "Measurment interval(min)",
      "downlink.xtiUnder": "Measurments per transmission",
      "downlink.th": "Threshold value",
      "downlink.miAbove": "Measurement interval(min)",
      "downlink.xtiAbove": "Measurments per transmission",
      "downlink.sectionLabel": "Downlink parameters",
      "downlink.aboveThresholdSectionLabel": "Above threshold value",
      "downlink.belowThresholdSectionLabel": "Below threshold value",
      "downlink.event": "Transmission event",
      "downlink.appliedConfig": "Applied configuration",
      "downlink.appliedAt": "Applied at",
      "downlink.messageCount": "Message count",
      uploadImgTitle: "Upload Picture of device ",
      soas_false_alarm: "False alarm",
      soas_thermocable: "New Thermocable",
      soas_power_cycle: "Restart",
      soas_replace_battery: "Replace battery",
      soas_replace_antenna: "Replace Antenna",
      soas_replace_device: "Replace Device",
      soas_replace_board: "Replace Board",
      unitServiceTitle: "Try and select the successful solutions",
      serviceGuide: "Open Service Guide",
      replacementNeeded: "Replacement needed",
      replacementNeededTitle: "Before Replacement",
      replacementConfirmationMSG: "Please remember to try previous solutions before choosing a replacement",
      backToSolutions: "Back To Solutions",
      backToReplacement: "I have tried the Solutions (Replace)",
      serviceComment: "Service comment",
      noDeviceData: "No data to display",
      replacementSolutionSelectorTitle: "Which replacement is needed?",
      "step.replacementOptions": "Replacement Options",
      clearSelectedSolutions: "Clear Selected Solutions",
      noDataAppear: "No Data Appear",
      soc_operational: "Operation Malfunction",
      soc_operational_explanation: "Device doesn't work due to environment/surroundings.",
      soc_missing: "Missing",
      soc_missing_explanation: "Device is missing/stolen.",
      soc_vandalism: "Vandalism",
      soc_vandalism_explanation: "Device has been vandalized",
      soc_malfunction: "Malfunction",
      soc_malfunction_explanation: "Malfunction due to hardware.",
      goBack: "Go back",
      showDetails: "Show Details",
      clickShowDetails: "Click on bars to Show Details",
      attachmentsTab: "Order Attachments",
      ImagesTab: "Device Images",
      orderDeviceHasOtherOrders: "This device has active order/s",
      selectAll: "Select all",
      doorSensor: "Door sensor",
      groundWaterSensor: "Groundwater sensor",
      weatherStation: "Weather station",
      weatherStationRain: "Weather station + rain",
      soilMoistureSensor: "Soilmoisture",
      personCounter: "Person counter",
      rainSensor: "Rain sensor",
      waterLevelPressure: "Waterlevel pressure",
      waterLevelPressureRain: "Waterlevel pressure + rain",
      waterLevelUltrasound: "Waterlevel ultrasound",
      waterLevelUltrasoundRain: "Waterlevel ultrasound + rain",
      waterLevelLiDAR: "Waterlevel LiDAR",
      dieselLevelPressure: "Diesel level pressure",
      waterLevel: "Waterlevel",
      trashButtons: "Trash buttons",
      streetSense: "StreetSense",
      camera: "Camera",
      fromHour: "From hour",
      toHour: "To hour",
      receiveAlarmNotification: "Receive alarm notifications only in following hours(optional):",
      createAlarm: "Create new alarm",
      editAlarm: "Edit alarm",
      networkStrength: "Network strength",
      networkType: "Network type",
      networkProtocol: "Network Protocol",
      noNetworkInfoAvailable: "No network information available",
      networkId: "Network ID",
      networkInfo: "Network info",
      waterLevel: "Waterlevel",
      precipitation: "Precipitation",
      personCount: "Person count",
      overflowThreshold: "Overflow threshold",
      distance: "Distance",
      dieselLevel: "Diesel niveau",
      airTemperature: "Air temperature",
      roadTemperature: "Road temperature",
      airHumidity: "Air humidity",
      batteryLevel: "Battery level",
      batteryVoltage: "Battery voltage",
      personCountInDirection: "Right direction",
      personCountOutDirection: "Left direction",
      waterlevel: "Waterlevel ",
      personCounter: "Person counter",
      "organizations.addUser": "Add user",
      "organizations.editUser": "Edit user",
      "organizations.removeUser": "Remove user",
      "organizations.createAndAddUser": "Create & add user",
      "organizations.keys.createKey": "Create new API key",
      "organizations.keys.deleteKey": "Delete API key!",
      ap: "Create new API key",
      "groups.createGroup": "Create new group",
      "groups.updateGroup": "Update group",
      "groups.deleteGroup": "Delete group",
      selectDevices: "Select devices...",
      createNewUser: "Create new user",
      fullName: "Full name",
      phoneNo: "Phone number",
      password: "Password",
      passwordConfirm: "Confirm password",
      firmwareVersion: "Firmware version",
      wifi_ssid: "Wifi SSID",
      wifi_username: "Wifi username",
      wifi_password: "Wifi password",
      sntp_server: "SNTP server",
      iot_mode: "IoT mode",
      iot_priority: "IoT priority",
      temp_threshold_upper: "Temperature threshold upper",
      temp_threshold_lower: "Temperature threshold lower",
      measurements_threshold: "Measurements threshold",
      measurements_no_threshold: "Measurements outside threshold",
      measurement_interval_no_threshold: "Measurement interval(min) outside threshold",
      measurement_interval: "Measurement interval(min)",
      upload_interval: "Upload interval(# of measurements) inside threshold",
      upload_interval_no_threshold: "Upload interval(# of measurements) outside threshold",
      temp_interval: "Temperature interval",
      cam_inside_threshold_min: "Upload interval(min) inside threshold",
      cam_outside_threshold_min: "Upload interval(min) outside threshold",
      cam_max_tries: "Camera max tries",
      cam_gdpr_samples: "Camera samples",
      cam_color: "Camera color",
      cam_gdpr_resolution: "Camera resolution",
      cam_gdpr_quality_percent: "Camera quality(%)",
      cam_jpeg_max_size_kb: "Camera JPEG max size KB",
      cam_reset_timeout_ms: "Camera reset timeout(ms)",
      cam_frametime_sec: "Camera frametime(sec)",
      cam_gdpr_frame_delay_sec: "Camera GDPR frame delay(sec)",
      network_settings: "Network settings",
      measurement_intervals: "Measurement intervals",
      upload_intervals: "Upload intervals",
      cam_settings: "Camera settings",
      firmware_settings: "Firmware settings",
      firmware_name: "Firmware name",
      applied_at: "Applied at",
      firmware_checksum: "Firmware checksum",
      time: "Time",
      device_type: "Device type",
      sequenceNumber: "Sequence number",
      transmissionSeqNumber: "Transmission sequence number",
      attachCSVFile: "Attach a csv-file",
      errorCode: "Error code",
      startService: "Start service",
      serviceOrder: "Service Order",
      openServiceOrderTooltip: "Has a new or in-progress service order",
      showServiceOrder: "Show service order",
      showServiceHistory: "Show service history",
      goToDevice: "Show device",
      notes: "Notes",
      deviceModel: "Device model",
      lastErrorOcurredAt: "Latest error date",
      monitoring: "Monitoring",
      monitoringPageTitle: "Monitoring overview",
      latest_image: "Latest image",
      batteryInfo: "Battery info",
      addNewFirmware: "Add new firmware",
      deleteFirmware: "Delete firmware",
      show_latest_image: "Show latest image",
      show_road_images: "Display road images",
      select_date: "Select date",
      show_surpassed_due_date: "Show surpassed due date only",
      batteryPack: "Battery pack",
      big: "Big",
      small: "Small",
      event3: "Event 3 (Reboot)",
      submit: "Submit",
      update: "Update",
      removed_from_org: "Removed from organisation",
      removed_from_group: "Removed form group",
      added_to_group: "Added to group",
      author: "Author",
      changes: "Changes",
      see_changes: "See changes",
      see_details: "See details",
      addServiceOrder: "Add service order",
      lastLogin: "Last login",
      syncMetaData: "Syncronize metadata",
      fromOrg: "From organization(stock)",
      toOrg: "To organization(operation)",
      preserveData: "Preserve historic data",
      putInStock: "Put in stock",
      permanentDelete: "Permanent deletion",
      selectToOrgMsg: "Select organization to transfer(or keep) device to",
      serviceLevel: "Service level",
      errorDate: "Error date",
      selectDevice: "Select device",
      installedAt: "Installed",
      probeTemperature: "Water temperature",
      systemIntegration: "System integration",
      lastHour: "Hour",
      editUserInfo: "Edit user info",
      changePassword: "Change password",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmNewPassword: "Confirm new password",
      deleteUser: "Delete user",
      deleteUserMSG: "Are you sure you want to delete this user?",
      confirmDeleteUser: "Yes, delete user",
      signInAs: "Sign in as",
      memberOfOrgs: "Member of organizations",
      audit: "Audit activity logs",
      confirmDeviceBoardId: "Confirm device board ID",
      runTheMagnetMsg:
        "Run the magnet on the devices cover for 3 seconds. Wait 30 seconds and click refresh to confirm data is received.",
      ahead: "Ahead",
      deviceModelImageLabel: "Device model example image.",
      confirmDeviceSerialNumber: "Confirm device serial number",
    },
  },
  da: {
    translation: {
      "dashboard.devices": "Enheder",
      "dashboard.device": "Enhed",
      "dashboard.deviceType": "Enhedstype",
      "dashboard.notifications": "Notifikationer",
      "chart.deviceId": "Enheds ID",
      "chart.deviceIds": "Enheder IDs",
      "chart.measurements": "Målinger",
      dashboard: "Dashboard",
      users: "Brugere",
      roles: "Roller",
      organizations: "Organisationer",
      organization: "Organisation",
      devices: "Enheder",
      map: "Kort",
      elevation: "Vis i kote",
      language: "Sprog",
      account: "Konto",
      login: "Log ind",
      logout: "Log ud",
      latestDay: "Dag",
      latestWeek: "Uge",
      latestMonth: "Måned",
      latestThreeMonths: "3 måneder",
      customDateSelector: "Brugerdefinerede datoer",
      OpenInGoogleMaps: "Åbn i Google Maps",
      doubleClickToOpenInGoogleMaps: "Dobbeltklik for at åbne i Google Maps",
      noBatteryData: "Ingen batteri data leveret!",
      startDate: "Startdato",
      endDate: "Slutdato",
      viewFullscreen: "Vis i fuld skærm",
      exitFullscreen: "Afslut fuld skærm",
      hideAdvancedFiltering: "Skjul filter",
      showAdvancedFiltering: "Vis filter",
      applyFilter: "Anvend filtre",
      clearFilter: "Ryd filtre",
      ownersLabel: "Organisationer",
      deviceTypesLabel: "Enhedstyper",
      devicesModelsLabel: "Enhedsmodeller",
      devicesListLabel: "Enhedsliste",
      timePeriodsLabel: "Periode",
      NoMatchingDevicesFound: "Ingen matchende enheder fundet",
      NoFiltersSelectedToApply: "Ingen filtre valgt at anvende",
      createNewDevice: "Opret ny enhed",
      bulkCreateNewDevices: "Opret flere enheder",
      GetCurrentGeolocation: "Få nuværende lokation",
      geolocationAlertMSG_PERMISSION_DENIED: "Du nægtede anmodningen om Geolocation.",
      geolocationAlertMSG_POSITION_UNAVAILABLE: "Placeringsoplysninger er ikke tilgængelige.",
      geolocationAlertMSG_TIMEOUT: "Forespørgslen om at få brugerens placering udløbet.",
      geolocationAlertMSG_UNKNOWN_ERROR: "Der opstod en ukendt fejl.",
      geolocationAlertMSG_HAS_PERMISSION: "Flyt markøren på kortet.",
      geolocationAlertMSG_MUST_GIVE_PERMISSION: "Du skal give placeringstilladelse til din browser",
      NoDeviceSelected: "Ingen valgt enhed, vælg venligst mindst en enhed",
      savedGeoLocation: "Gemt lokation",
      geoLocation: "Geolokation(lat,lng)",
      edit: "Rediger",
      notifications: "Notifikationer",
      alert: "Alarm",
      alerts: "Alarmer",
      alarm: "Alarm",
      alarms: "Alarmer",
      loading: "Indlæser...",
      loadingData: "Henter data...",
      printChart: "Udskriv diagram",
      downloadPNG: "Download PNG",
      downloadJPEG: "Download JPEG",
      downloadPDF: "Download PDF",
      downloadSVG: "Download SVG",
      downloadCSV: "Download CSV",
      value: "Værdi",
      action: "Handling",
      name: "Navn",
      cancel: "Annuller",
      confirm: "Bekræft",
      add: "Tilføj",
      moreDetails: "Flere detaljer",
      hideDetails: "Skjul detaljer",
      created: "Oprettet",
      hours_one: "Time",
      hours_other: "Timer",
      minutes_one: "Minut",
      minutes_other: "Minutter",
      evaluationFrequency: "Evaluerings frekvens",
      lastRun: "Seneste kørsel",
      equal: "Lige med",
      ">=": "Større end eller lig med",
      ">": "Større end",
      "<=": "Mindre end eller lig med",
      "<": "Mindre end",
      average: "Gennemsnit",
      minimum: "Minimum",
      maximum: "Maksimum",
      total: "Total",
      delete: "Slet",
      confirmAction: "Er du sikker på at du vil udføre denne handling?",
      create: "Opret",
      save: "Gem",
      counters: "Tællere",
      compare: "Sammenlign",
      dataAnalytics: "Dataanalyse",
      scheduling: "Planlægning",
      groups: "Grupper",
      reference: "Reference",
      period: "Periode",
      date: "Dato",
      multipleEmails: "Brug semikolon til at separere flere modtagere",
      organizationHasnoDevices: "Denne organisation har endnu ingen enheder",
      obs: "OBS!",
      totalperson: "i alt",
      activitiesThisPeriod: "For denne periode",
      lastReading: "Seneste måling",
      noDataAvailable: "Ingen tilgængelig data",
      pleaseSelectOrganization: "Vælg organisation...",
      activities: "Tællinger d.",
      chartRef: "Referencer",
      chartData: "Tællinger",
      schedulingChartData: "Akkumulerede tælling",
      createNewGroupsFirst: "Opret først nye grupper",
      noGroupsFound: "Ingen grupper fundet",
      lastResetAt: "Siden nulstillingen d. ",
      totalCounts: "Antal tællinger",
      serviceTarget: "Service mål",
      setnewThreshold: "Indstil ny service mål",
      useSemicolon: "Brug semikolon til at separere flere modtagere",
      notificationEmails: "Underretnings e-mail(s)",
      serviceThreshold: "Service mål",
      apply: "Anvend",
      serviceThresholdPlaceholder: "Service mål(kun tal)",
      chartServiceTargetCount: "Service mål",
      resetService: "Nulstil",
      resetServiceHeader: "Service afsluttet",
      resetServiceMessage: "Du har udført service og vil nulstille for ",
      resetSuccessfully: "Service er nulstillet",
      SetNewThresholdSuccessfully: "Ny Service mål er indstillet",
      day: "Dag",
      week: "Uge",
      month: "Måned",
      noReference: "Ingen reference",
      devicePrevPeriod: "Samme enhed forrige periode",
      groupAvgSamePeriod: "Samme periode gruppe gennemsnit",
      resets: "Nulstillinger",
      devicesListPlaceholder: "Vælg en eller flere enheder ...",
      interval: "Sidst modtaget",
      on: "d.",
      at: "kl.",
      counts: "Tællinger",
      goodRoadTemp: "Vejtemperaturen er mere end +2°C",
      warningRoadTemp: "Vejtemperaturen er mellem 0°C og +2°C",
      dangerRoadTemp: "Vejtemperaturen er under 0°C",
      inactiveDevice: "inaktiv",
      activeDevice: "aktiv",
      showMapControls: "Vis kortkontrol",
      mapThemes: "Kort temaer",
      filterApplied: "Filter anvendt",
      DeviceInfo: "Information",
      DeviceServices: "Services",
      DeviceData: "Data",
      DeviceDownlink: "Downlink",
      DeviceAlarms: "Alarmer",
      DeviceContracts: "Kontrakter",
      DeviceDebugMessages: "Debug",
      debugMessagesLoadError: "Kunne ikke indlæse debug-beskeder",
      "debugField.E0": "E0: Modem-opstartsfejl",
      "debugField.E1": "E1: Netværksforbindelsesfejl (120 s)",
      "debugField.E2": "E2: Netværksforbindelsesfejl (300 s)",
      "debugField.E3": "E3: MQTT-konfigurationsfejl",
      "debugField.E4": "E4: MQTT-forbindelsesfejl",
      "debugField.E5": "E5: MQTT-publiceringsfejl",
      "debugField.S": "S: Afsendelsesforsøg",
      "debugField.A": "A: Gns. afsendelsestid (s)",
      "debugField.T": "T: Gns. tid, alle forsøg (s)",
      debugMessagesSecondsAxis: "Sekunder",
      "form.solution": "Løsning",
      "form.serviceCause": "Serviceårsag",
      "form.device": "Enheds ID",
      "form.name": "Enhedsnavn",
      "form.locationId": "Lokations ID",
      "form.geo.lat": "Breddegrad",
      "form.geo.lon": "Længdegrad",
      "form.email": "Email",
      "form.placeName": "Noter",
      "form.serialNumber": "Serienummer",
      "form.deleted": "Aktiv",
      "form.deleted.true": "Ja",
      "form.deleted.false": "Ingen",
      "form.state": "State",
      "form.device_model": "Enhedsmodel",
      "form.device_type": "Enhedstype",
      "form.lastSeenAt": "Sidst set",
      "form.created_at": "Oprettet",
      "form.completedAt": "Afsluttet",
      "form.minVWC": "Min VWC",
      "form.maxVWC": "Max VWC",
      "form.elevation": "Kote(m)",
      "form.boundary_distance": "Maks dybde(cm)",
      "form.heightOffset": "Højde offset(cm)",
      "form.overFlowThreshold": "Overflow tærskel(cm)",
      "form.deviceTypes.waterLevel": "Vandstandsmålere",
      "form.activeStatus": "Aktiv status",
      "form.owner": "Ejer",
      "form.technician": "Tekniker",
      "form.replacment": "Udskiftning",
      "replacement.allow": "Tilladt",
      "replacement.not_allow": "Ikke tilladt",
      "form.available_solutions": "Tilgængelige løsninger",
      "form.probeTempOffset": "Temperatur offset",
      locationTypeStancode: "Lokations type",
      requestReplaceDevice: "Anmod om enhed udskiftes",
      deactivated: "Deaktiveret",
      activated: "Aktiveret",
      deleteDevice: "Slet enheden permanent",
      takeDownDevice: "Nedtag enheden",
      deleteDeviceMSG: "Er du sikker på, at du vil slette denne enhed?",
      takeDownDeviceMSG: "Er du sikker på, at du vil nedtage denne enhed?",
      deleteDeviceWarning: "Vær opmærksom på, at følgende data slettes:",
      takeDownDeviceWarning: "Vær opmærksom på, at hvis du vælger ikke at bevare historiske data,at følgende data slettes:",
      deleteDeviceWarningItem1: "Alle data vil blive slettet",
      deleteDeviceWarningItem2: "Alle integrationer vil blive slettet",
      deleteDeviceWarningItem3: "Alle relationer til andre objekter(fx. kontrakter) vil blive slettet",
      deviceDeletedSuccess: "Enheden blev slettet",
      updateLocation: "Indtast geolocation manuelt",
      update: "Opdater",
      OldLatValue: "Gemte breddegrad",
      OldLonValue: "Gemte længdegrad",
      countryCode: "Landskode",
      mobileNumber: "Mobil nr.",
      dlc_stock: "På lager",
      dlc_installed: "Installeret",
      dlc_taken_down: "Nedtaget: På lager",
      state: "State",
      from: "Fra",
      to: "Til",
      first: "Først",
      last: "Sidst",
      prev: "Forrige",
      next: "Næste",
      listOfUsers: "Liste af Brugere",
      createNewUser: "Opret ny bruger",
      search: "Søg",
      clear: "Ryd",
      listOfDevices: "Liste af enheder",
      deviceType: "Enhedstype",
      deviceModel: "Enhedsmodel",
      battery: "Batteri",
      lastSeenAt: "Sidst set",
      globalUserRoles: "Globale bruger roller",
      members: "Medlemmer",
      contracts: "Kontrakter",
      contract: "kontrakt",
      member: "Medlem",
      createNewOrg: "Opret ny Organisation",
      listOfOrgs: "Liste af Organisationer",
      activeStatus: "Aktiv status",
      apiKeys: "API Nøgler",
      apiKey: "API Nøgle",
      optionalContactEmail: "Kontakt e-mail(valgfri)",
      addNewMember: "Tilføj ny medlem",
      user: "Bruger",
      remove: "Fjern",
      removeMember: "Fjern medlem!",
      sureAboutAction: "Er du sikker på at du vil udføre denne handling?",
      skippedHeartBeat: "Enheder som ikke har sendt data seneste 24 timer",
      history: "Historik",
      sent: "Sendt",
      channel: "Kanal",
      showMembers: "Vis medlemmer",
      showDevices: "Vis enheder",
      showList: "vis liste",
      unknown: "Ukendt",
      integration: "Integration",
      externalSystems: "Eksterne systemer",
      showIntegration: "Vis integration",
      clientProfileLabel: "Kunde profil",
      integrationSystemsLabel: "Systemintegration",
      integrationSystemsMessage: "Vælg et eksternt system",
      selectDeviceToIntegrateMessage: "Vælg de enheder, der skal integreres",
      clientProfileMessage: "Vælg Organisationsprofil hos eksternt system",
      integrate: "Integrere",
      availableDevices: "Tilgængelige enheder",
      integratedDevices: "Integrerede enheder",
      noIntegratedDeviceYet: "Ingen integreret enhed endnu",
      bc_home: "Forside",
      deleteOrgContact: `TKontrakt "{CNTCT}" slettes fra {ORG}.`,
      deleteDeviceIntegration: "Denne enhedsintegration med {SYS} slettes fra {ORG}.",
      created_at: "Oprettet: ",
      lastSyncedAt: "Sidst synkroniseret: ",
      tableTolat: "Viser {from} til {to} af {size} {item}",
      compactMode: "Kompakt tilstand",
      noDeviceName: "Enhedsnavnet er ikke tilgængeligt",
      "table.deviceName": "Enhedsnavn",
      "table.deviceId": "Netværks ID",
      "table.created_at": "Oprettet",
      "table.completedAt": "Afsluttet",
      "table.lastSyncedAt": "Sidst synkroniseret",
      "table.invoiceFrequencyInMonths": "Frekvens",
      "table.package": "Pakke",
      "table.start_date": "Start dato",
      "table.projectId": "ProjectId (ERP)",
      "table.debitorNumber": "Debitornr (ERP)",
      "table.lastSeenAt": "Sidst set kl",
      "table.installation_device_note": "Bemærkninger",
      actions: "Handlinger",
      addNewContract: "Tilføj ny kontrakt",
      pck_basic: "Basic",
      pck_premium: "Premium",
      deleteContactDeviceTitle: "Slet en enhed fra kontakten",
      deleteContactDeviceMSG: "Enhed '{DEVICE}' vil blive slettet, er du sikker?",
      contractNoDevices: "Denne kontrakt har endnu ingen tildelte enheder",
      installationOrderNoDevices: "Denne installationsordre har ingen tildelte enheder",
      orgNoContracts: "Denne {item} har endnu ingen tildelt kontrakt",
      deleteDevicesFirst: "Fjern alle enheder, der er tildelt denne kontrakt for at slette denne kontrakt",
      goToContractDetails: "Gå til kontraktoplysninger",
      devicePricePerMonth: "Enhedspris pr. Måned",
      assignDevices: "Tildel enheder",
      noAvailableDevices: "Ingen tilgængelige enheder",
      select: "Vælg",
      selectCameraDevice: "Vælg en kameraenhed...",
      showContractLogs: "Vis kontraktlogfiler",
      logs: "Logs",
      hideContractLogs: "Skjul kontraktlogfiler",
      contractLogsLabel: "Kontraktslogfiler",
      "table.transactions": "Transaktioner",
      "table.user": "Bruger",
      deviceNoContract: "Ingen kontrakter har denne enhed",
      "contract.logs.create": "skab",
      "contract.logs.update": "Opdatering",
      "contract.logs.delete": "Slet",
      "contract.logs.add_device_to_contract": "Føj enhed til kontrakt",
      "contract.logs.remove_device_from_contract": "Fjern enheden fra kontrakten",
      invoiceFrequencyInMonths: "Fakturafrekvens (måned)",
      note: "Bemærkning",
      org_name: "Organisation",
      package: "Pakke",
      package_name: "Pakke",
      projectId: "ProjectId",
      start_date: "Start dato",
      user_name: "Bruger",
      services: "Services",
      "tab.installation": "Installation",
      "tab.service-orders": "Services",
      "tab.technicians": "Teknikere",
      "tab.service-centers": "Servicecentre",
      "mode.table": "Tabel",
      "mode.grid": "Grid",
      "mode.map": "Kort",
      "mode.graph": "Graf",
      newOrder: "Ny ordre",
      newTechnician: "tilføj ny tekniker",
      addNewUser: "Tilføj ny bruger",
      editUser: "Redigere bruger",
      newServiceCenter: "tilføj nyt servicecenter",
      "filter.serviceCenter": "Service Center",
      "filter.technician": "Tekniker",
      "filter.owners": "Ejere",
      "filter.userStatus": "Brugerstatus",
      "filter.devicesType": "Enhedstyper",
      "filter.devicesModels": "Enhedsmodeller",
      totalDevices: "Samlede enheder",
      "breadcrumb.home": "Forside",
      "breadcrumb.dashboard": "Dashboard",
      "breadcrumb.users": "Brugere",
      "breadcrumb.user": "Bruger",
      "breadcrumb.roles": "Roller",
      "breadcrumb.role": "Role",
      "breadcrumb.organizations": "Organisationer",
      "breadcrumb.organization": "Organisation",
      "breadcrumb.devices": "Enheder",
      "breadcrumb.device": "Enhed",
      "breadcrumb.newDevice": "Opret enhed",
      "breadcrumb.map": "Kort",
      "breadcrumb.edit": "Rediger",
      "breadcrumb.new": "Ny",
      "breadcrumb.systemIntegrations": "Systemintegrationer",
      "breadcrumb.contracts": "Kontrakter",
      "breadcrumb.contract": "Kontrakt",
      "breadcrumb.apiKeys": "API nøgler",
      "breadcrumb.groups": "Grupper",
      "breadcrumb.obs": "OBS",
      "breadcrumb.services": "Services",
      "breadcrumb.serviceCenters": "Servicecentre",
      "breadcrumb.serviceCenterDetails": "Oplysninger om servicecenter",
      "breadcrumb.serviceCenterTechnicians": "Teknikere",
      "breadcrumb.newInstallationOrder": "Ny ordre",
      "breadcrumb.installations": "Installationer",
      "breadcrumb.installationsOrderDetails": "Ordre detaljer",
      "breadcrumb.installDevice": "Installer enhed",
      "breadcrumb.serviceOrders": "Serviceordrer",
      "breadcrumb.serviceWizard": "Udføre service",
      "breadcrumb.serviceDetails": "Serviceordre",
      "breadcrumb.editServiceDetails": "Rediger rækkefølge",
      "breadcrumb.orders": "Ordrer",
      addNewServiceCenterTitle: "Tilføj nyt servicecenter",
      editServiceCenterTitle: "Rediger servicecenter",
      "form.technicians": "Teknikere",
      "form.users": "Brugere",
      "form.usersMSG": "Vælg brugere, der skal tilføjes som teknikere til dette servicecenter",
      noServiceCenterTechnicians: "Ingen teknikere i dette servicecenter",
      "table.status": "Status",
      inactive: "inaktive",
      active: "Aktiv",
      removeTechnicianMgs: "Tekniker '{name}' fjernes fra '{center}'. Er du sikker på?",
      removeTechnicianHeader: "tekniker fra servicecenter",
      deactivateTTechnicianHeader: "Deaktiver tekniker",
      deactivate: "Deaktiver",
      activate: "Aktiver",
      deactivateTTechnicianMgs: "Tekniker '{name}' vil blive deaktiveret, er du sikker? ",
      setAsActive: "Aktivér dette servicecenter",
      avilableModels: "Tilgængelige modeller",
      avilableModelsMsg: "Alle tilgængelige modeller i valgt type",
      selectedModels: "Valgte modeller",
      selectedModelsMsg: "Alle modeller, som denne tekniker kan udføre service til",
      selectUserFirst: "Vælg Bruger først",
      editTecnicianTitle: "Rediger tekniker",
      addSelected: "Tilføj valgt",
      addAll: "Tilføj alle",
      removeAllModels: "Fjern alt",
      filters: "Filtre",
      inactiveTechnicianMsg: "Denne tekniker er inaktiv",
      newInstallationOrderTitle: "Ny installationsordre",
      newServicesOrderTitle: "Ny serviceordre",
      editServicesOrderTitle: "Rediger serviceordre",
      orderTitle: "Installations ordre: ",
      "form.orderName": "Navn",
      "form.orderOwner": "Ejer",
      "form.orderNotes": "Bemærkninger",
      "form.orderServiceCenter": "Servicecenter",
      "form.orderTechnician": "Tekniker",
      "form.orderDueDate": "Forfaldsdato",
      "form.types": "Typer",
      "form.models": "Modeller",
      "form.devices": "Enhedsliste",
      "form.deviceNote": "Enhedsnote",
      "form.orderIssue": "Problem",
      "form.startedAt": "Startede kl",
      noNotes: "Ingen noter fundet",
      orderNotes: "Ordrenotater",
      serviceNotes: "Efter servicenotater",
      addToOrder: "Tilføj til ordre",
      selectPlaceHolder: "Vælg ...",
      "order.ios_new": "Ny",
      "order.ios_in_progress": "I gang",
      "order.ios_completed": "Afsluttet",
      "order.ios_archived": "Arkiveret",
      "order.unknown": "Ukendt",
      deleteInstallationOrder: "Installationsordren '{ORDR}' slettes",
      cantDeleteInstallationOrder:
        "Installationsordren '{ORDR}' har installeret enheder, er du sikker på, at du skal slette den.",
      deleteInstallationOrderDevice: "Enheden '{DEVICE}' vil blive slettet fra ordren '{ORDR}'",
      deleteInstallationOrderDeviceAttatchment: "Vedhæftede filer '{FIL}' slettes fra serviceordren på enheden '{DEVICE}'",
      installationOrders: "Installationsordre (r)",
      noAttatchments: "Ingen vedhæftede filer fundet",
      selectFileMsg: "Træk og slip en fil her, eller klik for at vælge en fil",
      addNewDevices: "Tilføj enheder",
      "installation.installed": "Installeret",
      "installation.ready": "Klar til installation",
      viewDetails: "Se detaljer",
      installDevice: "Installere",
      noOrdersFound: "Ingen ordrer fundet",
      "step.location": "Enhedens placering",
      "step.information": "Enhedsinformation",
      "step.beforeService": "Før service billeder",
      "step.service": "Enhedsservice",
      "step.replacement": "Enhedsudskiftning",
      "step.causes": "Service årsager",
      "step.afterService": "Efter service billeder",
      "step.data": "Enhedsdata",
      "step.summary": "Installationsoversigt",
      "step.finish": "Afslut",
      "summary.deviceImages": "Enhedsbilleder",
      "summary.deviceLocation": "Enhedens placering",
      "summary.deviceData": "Enhedsdata",
      updateLocarion: "Opdater placering",
      fileTypeError: "Denne filtype understøttes ikke",
      fileSizeError: "Filstørrelsen er for stor, den maksimale filstørrelse er 5 MB",
      finish: "Afslut",
      newFilesLabel: "File/r klar til at blive uploadet",
      uploadAll: "Upload alle",
      mustUploadImgMSG: "Du skal uploade mindst et billede",
      hideInstalled: "Skjul ordrer med alle installerede enheder",
      AddingNewServiceOrderMsg: "Oprettelse af en ny serviceordre ...",
      EditingServiceOrderMsg: "Opdatering af serviceordre ...",
      AddingServiceOrderAttachmentsMsg: "Uploader vedhæftede serviceordrer ...",
      noServicesOrdersMsg: "Ingen serviceordrer endnu",
      attachments: "Vedhæftede filer",
      start: "Start",
      restart: "Genstart",
      continue: "Fortsæt",
      archive: "Arkiver",
      approve: "Godkende",
      decline: "Afvis",
      reject: "Afvise",
      installNewUnit: "Installer en ny enhed (Erstatte)",
      takeUnitDown: "Fjern denne enhed",
      "form.status": "Status",
      "form.issue": "Enhedsudgave",
      noneAdminPending: "Verserende...",
      cannotfindDevice: "Kan ikke finde enhed",
      deviceWorksFine: "Enheden fungerer fint",
      targetDevice: "Vælg ny enhed til udskiftning",
      timePeriodsListTitle: "Kopier tidsperioder",
      allData: "Alle data",
      today: "I dag",
      custom: "Brugerdefinerede",
      deleteServiceOrderMSG: "Er du sikker på, at du vil slette serviceordre?",
      archiveServiceOrderMSG: "Er du sikker på, at du vil arkivere serviceordre?",
      archiveInstallationOrderMSG: "Er du sikker på, at du vil arkivere installationsordren?",
      serviceOrderModalHeader: "Serviceordre hurtigvisningskort",
      confirmationModalTitle: "Gik installationsprocessen godt?",
      confirmationModalMSG: "Enheden virker ikke!",
      addDevice: "Tilføj enhed",
      selectImage: "Vælg billede",
      deviceData: "Enhedsdata",
      refresh: "Opdater",
      notes: "Bemærkninger",
      installationFailed: "Installationen mislykkedes!",
      owner: "Ejer",
      technician: "Tekniker",
      technicians: "Teknikere",
      status: "Status",
      showDeviceImages: "Vis enheds billeder",
      orders: "Ordrer",
      sos_unknown: "Ukendt",
      sos_new: "Ny",
      sos_in_progress: "I gang",
      sos_completed: "Afsluttet",
      sos_failed: "mislykkedes",
      sos_archived: "Arkiveret",
      noServiceOrdersMsg: "Ingen serviceordrer fundet",
      ios_new: "Ny",
      ios_in_progress: "I gang",
      ios_completed: "Afsluttet",
      ios_archived: "Arkiveret",
      showObsOnly: "vis OBS! Kun liste",
      duration: "Varighed",
      day: "dag/e",
      remaining: "resterende",
      showFilters: "Vis filtre",
      hideFilters: "Skjul filtre",
      qrcode: "QR-Kode",
      deviceQRtitle: "Enhedens QR-Kode",
      "downlink.miUnder": "Måleinterval(min)",
      "downlink.xtiUnder": "Antal målinger i en transmission",
      "downlink.th": "Grænseværdi",
      "downlink.miAbove": "Måleinterval(min)",
      "downlink.xtiAbove": "Antal målinger i en transmission",
      "downlink.sectionLabel": "Downlink parametre",
      "downlink.aboveThresholdSectionLabel": "Over grænseværdien",
      "downlink.belowThresholdSectionLabel": "Under grænseværdien",
      "downlink.event": "Transmissionshændelse",
      "downlink.appliedConfig": "Anvendt konfiguration",
      "downlink.appliedAt": "Anvendt tidsstempel",
      "downlink.messageCount": "Antal målinger",
      uploadImgTitle: "Upload billede af enheden ",
      soas_false_alarm: "Falsk alarm",
      soas_thermocable: "Nyt termokabel",
      soas_power_cycle: "Genstart",
      soas_replace_battery: "Udskift batteriet",
      soas_replace_antenna: "Udskift antenne",
      soas_replace_device: "Udskift enhed",
      soas_replace_board: " Udskift pcb board",
      unitServiceTitle: "Udfør service og marker herefter valgte løsning(er)",
      serviceGuide: "Åbn serviceguide",
      replacementNeeded: "Udskiftning nødvendig",
      replacementNeededTitle: "Før udskiftning",
      replacementConfirmationMSG: "Husk at prøve tidligere løsninger, inden du vælger en erstatning",
      backToSolutions: "Tilbage til løsninger",
      backToReplacement: "Jeg har prøvet løsningerne (Udskift)",
      serviceComment: "Servicekommentar",
      noDeviceData: "Ingen data at vise",
      replacementSolutionSelectorTitle: "Hvilken udskiftning er nødvendig?",
      "step.replacementOptions": "Udskiftningsmuligheder",
      clearSelectedSolutions: "Ryd valgte løsninger",
      noDataAppear: "Ingen data vises",
      soc_operational: "Driftsfejl",
      soc_operational_explanation: "Enheden fungerer ikke på grund af omgivelser.",
      soc_missing: "Mangler",
      soc_missing_explanation: "Enhed stjålet/forsvundet ",
      soc_vandalism: "Vandalisme",
      soc_vandalism_explanation: "Enheden har været udsat for hærværk.",
      soc_malfunction: "Funktionsfejl",
      soc_malfunction_explanation: "Enheden fungerer ikke pga. hardwarefejl.",
      goBack: "Gå tilbage",
      showDetails: "Vis detaljer",
      clickShowDetails: "Klik på søjler for at vise detaljer",
      attachmentsTab: "Ordre vedhæftede filer",
      ImagesTab: "Enhedsbilleder",
      orderDeviceHasOtherOrders: "Denne enhed har aktiv ordre/r",
      selectAll: "Vælg alle",
      doorSensor: "Dørsensor",
      groundWaterSensor: "Grundvandssensor",
      weatherStation: "Glatførerstation",
      weatherStationRain: "Glatførerstation + Regn",
      soilMoisture: "Jordfugtighedsmåler",
      personCounter: "Persontæller",
      rainSensor: "Regnsensor",
      waterLevelPressure: "Vandstandssensor Tryk",
      waterLevelPressureRain: "Vandstandssensor Tryk + Regn",
      waterLevelUltrasound: "Vandstandssensor Ultralyd",
      waterLevelUltrasoundRain: "Vandstandssensor Ultralyd + Regn",
      waterLevelLiDAR: "Vandstandssensor LiDAR",
      dieselLevelPressure: "Diesel tryk",
      streetSense: "StreetSense",
      camera: "Kamera",
      fromHour: "Fra kl.",
      toHour: "Til kl.",
      receiveAlarmNotification: "Modtag alarm notifikationer kun i følgende tidsrums(valgfri):",
      createAlarm: "Opret ny alarm",
      editAlarm: "Rediger alarm",
      networkStrength: "Netværksstyrke",
      networkType: "Netværkstype",
      networkProtocol: "Netværksprotokol",
      noNetworkInfoAvailable: "Ingen netværksoplysninger tilgængelige",
      networkId: "Netværks-id",
      networkInfo: "Netværksinfo",
      waterLevel: "Vandstand",
      precipitation: "Nedbør",
      soilMoisture: "Jordfugtighed",
      personCount: "Persontælling",
      overflowThreshold: "Overløbstærskel",
      distance: "Distance",
      dieselLevel: "Diesel level",
      airTemperature: "Luftemperatur",
      roadTemperature: "Vejtemperatur",
      airHumidity: "Luftfugtighed",
      batteryLevel: "Batteriniveau",
      batteryVoltage: "Batterispænding",
      personCountInDirection: "Højre retning",
      personCountOutDirection: "Venstre retning",
      waterlevel: "Vandstandsmåler ",
      personCounter: "Persontæller",
      soilMoistureSensor: "Jordfugtighedsmåler",
      "organizations.addUser": "Tilføj bruger",
      "organizations.editUser": "Rediger bruger",
      "organizations.removeUser": "Fjern bruger",
      "organizations.createAndAddUser": "Opret & tilføj bruger",
      "organizations.keys.createKey": "Opret ny API nøgle",
      "organizations.keys.deleteKey": "Delete API key!",
      "groups.createGroup": "Opret ny gruppe",
      "groups.updateGroup": "Opdater gruppe",
      "groups.deleteGroup": "Slet gruppe",
      selectDevices: "Select devices...",
      createNewUser: "Opret ny bruger",
      fullName: "Fulde navn",
      phoneNo: "Tlf. nr.",
      password: "Adgangskode",
      passwordConfirm: "Gentag adgangskode",
      firmwareVersion: "Firmware version",
      wifi_ssid: "Wifi SSID",
      wifi_username: "Wifi brugernavn",
      wifi_password: "Wifi kodeord",
      sntp_server: "SNTP server",
      iot_mode: "IoT mode",
      iot_priority: "IoT prioritet",
      temp_threshold_upper: "Temperatur tærskel øvre",
      temp_threshold_lower: "Temperatur tærskel nedre",
      measurements_threshold: "Målinger tærskel",
      measurements_no_threshold: "Antal målinger uden for tærskel",
      measurement_interval_no_threshold: "Måleinterval(min) uden for tærskel",
      measurement_interval: "Måleinterval(min)",
      upload_interval: "Upload interval(# af målinger)",
      upload_interval_no_threshold: "Upload interval(min) uden for tærskel",
      temp_interval: "Temperatur interval",
      cam_inside_threshold_min: "Upload interval(min) inden for tærskel",
      cam_outside_threshold_min: "Upload interval(min) uden for tærskel",
      cam_max_tries: "Kamera max forsøg",
      cam_gdpr_samples: "Kamera samples",
      cam_color: "Kamera farve",
      cam_gdpr_resolution: "Kamera opløsning",
      cam_gdpr_quality_percent: "Kamera kvalitet(%)",
      cam_jpeg_max_size_kb: "Kamera JPEG max størrelse kb",
      cam_reset_timeout_ms: "Kamera reset timeout(ms)",
      cam_frametime_sec: "Kamera framelængde(sekunder)",
      cam_gdpr_frame_delay_sec: "Kamera GDPR frame forsinkelse(sekunder)",
      network_settings: "Netværksindstillinger",
      measurement_intervals: "Måleintervaller",
      upload_intervals: "Uploadintervaller",
      cam_settings: "Kamera indstillinger",
      firmware_settings: "Firmware indstillinger",
      firmware_name: "Firmware navn",
      applied_at: "Anvendt dato",
      firmware_checksum: "Firmware checksum",
      time: "Tidspunkt",
      device_type: "Enhedstype",
      sequenceNumber: "Sekvensnummer",
      transmissionSeqNumber: "Transmissionssekvensnummer",
      attachCSVFile: "Vedhæft CSV-fil",
      errorCode: "Fejlkode",
      startService: "Igangsæt service",
      serviceOrder: "Serviceordre",
      openServiceOrderTooltip: "Har en ny eller igangværende serviceordre",
      showServiceOrder: "Vis serviceordre",
      showServiceHistory: "Vis service historie",
      goToDevice: "Vis enheden",
      notes: "Noter",
      lastErrorOcurredAt: "Seneste fejlkode dato",
      monitoring: "Monitorering",
      monitoringPageTitle: "Moniteringsoversigt",
      latest_image: "Seneste billede",
      batteryInfo: "Batteri info",
      addNewFirmware: "Tilføj ny firmware",
      deleteFirmware: "Slet firmware",
      show_latest_image: "Vis seneste billede",
      show_road_images: "Vis enhedsbilleder",
      select_date: "Vælg dato",
      show_surpassed_due_date: "Vis kun overskredet forfaldsdato",
      batteryPack: "Batteri pakke",
      big: "Stor",
      small: "Lille",
      event3: "Event 3 (Reboot)",
      submit: "Indsend",
      update: "Opdatering",
      removed_from_org: "Fjernet fra organisation",
      removed_from_group: "Fjernet fra gruppe",
      added_to_group: "Tilføjet til gruppe",
      author: "Bruger",
      changes: "Ændringer",
      see_changes: "Se ændringer",
      see_details: "Se detaljer",
      addServiceOrder: "Tilføj serviceordre",
      lastLogin: "Sidst logget ind",
      syncMetaData: "Synkroniser metadata",
      fromOrg: "Fra organisation(lager)",
      toOrg: "Til organisation(drift)",
      preserveData: "Behold data",
      putInStock: "Sæt på lager",
      permanentDelete: "Permanent sletning",
      selectToOrgMsg: "Vælg en organisation at overføre(el. beholde) enheden til",
      serviceLevel: "Serviceniveau",
      errorDate: "Fejldato",
      selectDevice: "Vælg enhed",
      installedAt: "Installeret",
      probeTemperature: "Vandtemperatur",
      systemIntegration: "Systemintegration",
      lastHour: "Seneste time",
      editUserInfo: "Rediger brugerinfo",
      changePassword: "Skift adgangskode",
      currentPassword: "Nuværende adgangskode",
      newPassword: "Ny adgangskode",
      confirmNewPassword: "Bekræft ny adgangskode",
      deleteUser: "Slet bruger",
      deleteUserMSG: "Er du sikker på, at du vil slette denne bruger?",
      passwordNotMatch: "Adgangskoderne matcher ikke",
      confirmDeleteUser: "Ja, slet bruger",
      signInAs: "Log ind som",
      memberOfOrgs: "Medlem af organisation(er)",
      audit: "Audit aktivitetslogs",
      confirmDeviceBoardId: "Bekræft enheds board ID",
      runTheMagnetMsg:
        "Kør magneten på enhedens dæksel i 3 sekunder. Vent 30 sekunder og klik på opdater for at bekræfte, at data er modtaget.",
      ahead: "Ahead",
      deviceModelImageLabel: "Enhedsmodel billed eksempel.",
      confirmDeviceSerialNumber: "Bekræft enhedsserienummer",
    },
  },
};

i18n.use(initReactI18next).init({
  resources: translations,
  fallbackLng: localStorage.getItem("selected_language") ? localStorage.getItem("selected_language") : "da",
  lng: localStorage.getItem("selected_language") ? localStorage.getItem("selected_language") : "da",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
